export default class Tab
{
	constructor()
	{
		this.current = 0
		this._tab = document.querySelectorAll(".jsTabSwitch");
		this._tabHead = document.querySelector('.dynamic-tabs__head')
		this._tabCheckout = document.querySelector(".jsTabCheckout");
		this._tabItems = document.querySelectorAll(".jsDynamicTabsItem")
		this._tabSections = document.querySelectorAll(".jsTabSection")
		this.init();
	}

	tabTemplate (id, name)
	{
		return `<div class="dynamic-tabs__link ${id === 1 ? 'active' : ''} jsDynamicTabsHead" data-id="${id}">${name}</div>`
	}

	build ()
	{
		let l = this._tabItems.length
		let html = ''

		this._tabItems[0].classList.add('active')

		for (let i = 1; i <= l; i++)
		{
			html += this.tabTemplate(i, this._tabItems[i-1].getAttribute('data-name'))
			this._tabItems[i - 1].setAttribute('data-id', i)
		}

		this._tabHead.innerHTML = html
	}

	getContent(i, data)
	{
		let content = i.parentElement.parentElement.parentElement.parentElement.querySelectorAll(".jsTabSection");

			let l = content.length;
			for (let i = 0; i < l; i++)
			{
				content[i].dataset.id == data
				? content[i].classList.add("active")
				: content[i].classList.remove("active");
			}
		}

		switchHeader(data)
		{
			let l = this._tab.length;
			for (let i = 0; i < l; i++)
			{
				if (this._tab[i].dataset.id == data)
				{
					this._tab[i].classList.add("active");

					if (this._tab[i].classList.contains("donate"))
					this.switchColor(this._tab[i], data);
				} else
				{
					this._tab[i].classList.remove("active");
				}
			}
		}

		switchColor(i, data)
		{
			switch (parseInt(data))
			{
				case 0:
				i.parentElement.classList.remove("switcher--orange");
				i.parentElement.classList.add("switcher--blue");
				this._tabCheckout.classList.remove("btn--orange");
				this._tabCheckout.classList.add("btn--blue");
				break;
				case 1:
				i.parentElement.classList.remove("switcher--blue");
				i.parentElement.classList.add("switcher--orange");
				this._tabCheckout.classList.remove("btn--blue");
				this._tabCheckout.classList.add("btn--orange");
				break;
			}
		}

		init()
		{
			if (this._tabItems.length > 0) this.build()
			let l = this._tab.length;
			for (let i = 0; i < l; i++)
			{
				this._tab[i].addEventListener("click", () =>
				{
					this.current = i
					this._tab[i];
					this.getContent(this._tab[i], this._tab[i].dataset.id);
					this.switchHeader(this._tab[i].dataset.id);
				});
			}
		}
	}
